function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.918 33.4994H23.0846V29.3327H18.918V33.4994ZM21.0013 0.166016C9.5013 0.166016 0.167969 9.49935 0.167969 20.9994C0.167969 32.4994 9.5013 41.8327 21.0013 41.8327C32.5013 41.8327 41.8346 32.4994 41.8346 20.9994C41.8346 9.49935 32.5013 0.166016 21.0013 0.166016ZM21.0013 37.666C11.8138 37.666 4.33464 30.1869 4.33464 20.9994C4.33464 11.8119 11.8138 4.33268 21.0013 4.33268C30.1888 4.33268 37.668 11.8119 37.668 20.9994C37.668 30.1869 30.1888 37.666 21.0013 37.666ZM21.0013 8.49935C16.3971 8.49935 12.668 12.2285 12.668 16.8327H16.8346C16.8346 14.541 18.7096 12.666 21.0013 12.666C23.293 12.666 25.168 14.541 25.168 16.8327C25.168 20.9994 18.918 20.4785 18.918 27.2494H23.0846C23.0846 22.5619 29.3346 22.041 29.3346 16.8327C29.3346 12.2285 25.6055 8.49935 21.0013 8.49935Z",
  fill: "#3456FF"
});

function SvgIconQuestionsOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionsOutlined);
export default __webpack_public_path__ + "static/media/icon-questions-outlined.aea45cf2.svg";
export { ForwardRef as ReactComponent };